import { useTranslation } from "react-i18next";
import { useRemoveCartItemMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for removing an item from the cart.
 */
export const useRemoveCartItemFromCart = () => {
  const { t } = useTranslation();
  const [removeCartItem, removeResult] = useRemoveCartItemMutation();

  const { trigger: handleRemoveCartItem, isLoading: isRemoving } =
    useMutationWithFeedback({
      mutation: [removeCartItem, removeResult],
      loadingMessage: t(
        "feedback.cart.product.removeFromCartLoading",
        "Removing from cart..."
      ),
      successMessage: t(
        "feedback.cart.product.removeFromCartSuccess",
        "Removed from cart!"
      ),
      errorMessages: {
        default: t(
          "feedback.cart.product.removeFromCartError",
          "Failed to remove product from cart. Please try again."
        ),
      },
      successToastType: "info",
    });

  return {
    handleRemoveCartItem,
    isRemoving,
  };
};
